import { axiosIntance } from "./config";


export const getAllEnquiry = async () => {
  const response = await axiosIntance.get('/enquirys');
  return response.data;
};




export const getEnquirys = async () => {
  const response = await axiosIntance.get("/enquirys"); 
  return response.data;
};



export const createEnquiry = async (data) => {
  const response = await axiosIntance.post('/enquirys', data);
  return response.data;
};



/* export const updateEnquiry = async (id) => {
  const response = await axiosIntance.put(`/enquirys/${id}/status`);
  return response.data;
}; */

export const updateEnquiry = async (id, payload) => {
  const response = await axiosIntance.put(`/enquirys/${id}/status`, payload);
  return response.data;
};





export const deleteEnquiry = async (id) => {
  const response = await axiosIntance.delete(`/enquirys/${id}`);
  return response.data;
};
